import supportModule from '../../support.module';

export default supportModule.component('supportCreateCase', {
    styleUrls: require('./supportCreateCase.component.css'),
    template: require('./supportCreateCase.component.html'),
    controller: ['supportCreateCaseService', 'asNotifier', 'textResources', 'stringHelper', '$state', 'asLoadingMask', 'stateConstants', supportCreateCaseComponent]
});

function supportCreateCaseComponent(supportCreateCaseService, asNotifier, textResources, stringHelper, $state, asLoadingMask, stateConstants) {
    var vm = this;
    vm.$onInit = () => {
        vm.submitDisable = false;
        vm.paths = [
            { label: textResources.supportCaseHistoryTitle, sref: stateConstants.support.overview.name, value: stateConstants.support.overview.name },
            { label: textResources.supportCreateCaseTitle }
        ];

        supportCreateCaseService.getCaseForm().then(
            data => {
                vm.form = data;
            },
            function() {
                asNotifier.error(textResources.configurationNotLoaded);
            }
        );

        vm.onSubmit = () => {
            if (vm.submitDisable) {
                return;
            }
            vm.submitDisable = true;
            asLoadingMask.show();
            supportCreateCaseService
                .createCase(vm.form.items)
                .then(
                    function(data) {
                        asNotifier.success(stringHelper.format(textResources.createCaseSuccess, data));
                        $state.go('support_viewcase', { caseId: data.id });
                    },
                    function() {
                        asNotifier.error(textResources.createCaseFailed);
                        $state.go('support_overview');
                    }
                )
                .finally(function() {
                    asLoadingMask.hide();
                });
        };
    };
}



// WEBPACK FOOTER //
// ./modules/support/components/support-create-case/supportCreateCase.component.js